export default __webpack_public_path__ + "static/media/circle-unchecked.43565c23.svg";